import React from "react";
import { Link } from "react-router-dom";

// Hub principal Assist : coaching mental et guidage par l'IA.
export default function AssistHub() {
  const sections = [
    { title: "Coaching mental", to: "/assist/coaching", desc: "Préparer des sessions de coaching cognitif assisté." },
    { title: "Introspection", to: "/assist/introspection", desc: "Journal guidé et questions puissantes." },
    { title: "Analyse", to: "/assist/analyse", desc: "Analyser des situations et clarifier les options." },
    { title: "Décisions guidées", to: "/assist/decisions", desc: "Modèles mentaux et arbres de décision assistés." },
  ];

  return (
    <div className="max-w-6xl mx-auto space-y-8">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold text-slate-900 dark:text-white">MixMind Assist</h1>
        <p className="text-sm md:text-base text-slate-700 dark:text-slate-300">
          Un futur espace pour se faire guider par l&apos;IA : coaching mental, introspection, analyse et
          décisions accompagnées.
        </p>
      </header>

      <section className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {sections.map((s) => (
          <Link
            key={s.to}
            to={s.to}
            className="mm-surface p-4 hover:-translate-y-0.5 hover:shadow-md transition-transform"
          >
            <h2 className="text-lg font-semibold mb-1">{s.title}</h2>
            <p className="text-sm text-slate-700 dark:text-slate-300">{s.desc}</p>
          </Link>
        ))}
      </section>
    </div>
  );
}

